import { Box, Icon, IconTile, ListRow, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { urlBuilder } from '../../../../Shared/urlBuilder';
import { PurposeType } from '../../FlowConfig';

type CreateNewPurposeButtonProps = {
  purposeType: PurposeType;
};

const createNewString = (type: PurposeType): string => {
  switch (type) {
    case 'emergency_fund':
      return 'Create new emergency fund';
    case 'retirement':
      return 'Create new retirement goal';
    case 'major_purchase':
      return 'Create new goal';
    default:
      return '';
  }
};

export const CreateNewPurposeButton: React.FC<CreateNewPurposeButtonProps> = ({ purposeType }) => {
  return (
    <SambaAutoLink
      to={urlBuilder.appRedirectToPurposeFlow.absolute({ purposeType })}
      variant="ghostSecondary"
      spacing="compact"
      css={{
        px: 0,
        py: 0,
        borderStyle: 'solid',
        borderWidth: 'thin',
        borderColor: 'border.weak',
        borderRadius: 'medium',
      }}
    >
      <ListRow css={{ w: '100%' }}>
        <ListRow.LeadingAsset>
          <Box css={{ w: 'size.450', h: 'size.450' }}>
            <IconTile name="Plus" css={{ bg: 'background.neutral' }} />
          </Box>
        </ListRow.LeadingAsset>
        <ListRow.LeadingContent>
          <Text>{createNewString(purposeType)}</Text>
        </ListRow.LeadingContent>
        <ListRow.TrailingAsset>
          <Icon name="CaretRight" size="small" />
        </ListRow.TrailingAsset>
      </ListRow>
    </SambaAutoLink>
  );
};
